// extracted by mini-css-extract-plugin
export default {"wrapper":"PlusAndMinus_wrapper__SP5c4","button":"PlusAndMinus_button__sXvNR"};